import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useCallback } from 'react';
import { usePortalsAuth, HubSpotForm, getPortalEnv, getPortalHublet } from 'portals-platform-lib';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const CONTACT_EMAIL_FIELD_NAME_BY_FORM_VERSION = {
  1: 'email',
  2: '0-1/email'
};
export function TicketCreation({
  onSuccess,
  formGuid,
  portalData
}) {
  var _getPortalEnv;
  const {
    user
  } = usePortalsAuth();
  const email = user === null || user === void 0 ? void 0 : user.email;
  const onFormSubmitted = useCallback(() => {
    FloatingAlertStore.addAlert({
      message: I18n.text('customer-portal-app.ticketSubmittedAlert.message'),
      titleText: I18n.text('customer-portal-app.ticketSubmittedAlert.title'),
      type: 'success'
    });
    onSuccess();
  }, [onSuccess]);
  const onFormReady = useCallback(instance => {
    if (email) {
      const fieldName = CONTACT_EMAIL_FIELD_NAME_BY_FORM_VERSION[instance.version];
      try {
        instance.setFieldValue(fieldName, email);
      } catch (error) {
        console.error('Failed to prefill the standard contact email field', {
          errorType: error instanceof Error ? error.name : typeof error,
          fieldName,
          formGuid,
          formVersion: instance.version
        });
      }
    }
  }, [email, formGuid]);
  return /*#__PURE__*/_jsx(HubSpotForm, {
    formId: formGuid,
    portalId: String(portalData.portalId),
    env: (_getPortalEnv = getPortalEnv()) !== null && _getPortalEnv !== void 0 ? _getPortalEnv : '',
    region: getPortalHublet(),
    onFormReady: onFormReady,
    onFormSubmitted: onFormSubmitted,
    loadingFallback: /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlock: "400",
      "aria-label": I18n.text('customer-portal-app.loading')
    })
  });
}